"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("src/api");
const contractNumber_1 = require("src/modules/references/purchases/contractNumbers/store/contractNumber");
const react_1 = require("react");
const indexs_1 = require("src/modules/references/purchases/contractNumbers/helpers/indexs");
const react_router_dom_1 = require("react-router-dom");
const useContractNumber = (props) => {
    const [state, dispatch] = (0, contractNumber_1.useContractNumberReducer)();
    const [purchaseUsers, setPurchaseUsers] = (0, react_1.useState)([]);
    const [loadingPurchaseUsers, setLoadingPurchaseUsers] = (0, react_1.useState)(false);
    const [cancelNumberAlert, setCancelNumberAlert] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const getContractNumber = async (id) => {
        dispatch({ type: 'SEND_CONTRACT_NUMBER_REQUEST' });
        const contractNumber = await api_1.ContractNumberApi.getContractNumber(id);
        dispatch({ type: 'DONE_CONTRACT_NUMBER_REQUEST', payload: contractNumber });
    };
    const getPurchaseUsers = async () => {
        setLoadingPurchaseUsers(true);
        const userData = await api_1.StructuralUnitsUpgradedApi.getHrEmployee({ abbr: 'purchases' });
        if (userData.data !== null) {
            setPurchaseUsers(userData.data.map(user => {
                return {
                    id: user.userId || '',
                    label: user.name || ''
                };
            }));
        }
        setLoadingPurchaseUsers(false);
    };
    const createContractNumber = async (values) => {
        const params = (0, indexs_1.transformContractNumberParams)(values);
        dispatch({ type: 'SEND_CONTRACT_NUMBER_CREATE' });
        const contractNumber = await api_1.ContractNumberApi.createContractNumber(params);
        dispatch({ type: 'DONE_CONTRACT_NUMBER_CREATE', payload: contractNumber });
        if (contractNumber.data !== null) {
            navigate(`/references/purchases/contract-numbers/${contractNumber.data.id}/edit`);
        }
        return contractNumber;
    };
    const updateContractNumber = async (id, values) => {
        const params = (0, indexs_1.transformContractNumberParams)(values);
        dispatch({ type: 'SEND_CONTRACT_NUMBER_UPDATE' });
        const contractNumber = await api_1.ContractNumberApi.updateContractNumber(id, params);
        dispatch({ type: 'DONE_CONTRACT_NUMBER_UPDATE', payload: contractNumber });
        return contractNumber;
    };
    const contractNumbersCancel = async (id) => {
        dispatch({ type: 'SEND_CONTRACT_NUMBER_CANCEL' });
        const contractNumber = await api_1.ContractNumberApi.contractNumbersCancel(id);
        dispatch({ type: 'DONE_CONTRACT_NUMBER_CANCEL', payload: contractNumber });
        return contractNumber;
    };
    const closeErrorMessage = (index) => {
        dispatch({ type: 'REMOVE_ERROR', payload: index });
    };
    (0, react_1.useEffect)(() => { if (props.id)
        getContractNumber(props.id).then(); }, [props.id]);
    return {
        state,
        createContractNumber,
        updateContractNumber,
        getContractNumber,
        closeErrorMessage,
        purchaseUsers,
        loadingPurchaseUsers,
        getPurchaseUsers,
        contractNumbersCancel,
        setCancelNumberAlert,
        cancelNumberAlert
    };
};
exports.default = useContractNumber;
